import { render, staticRenderFns } from "./PendingStep.vue?vue&type=template&id=25157c1c"
import script from "./PendingStep.vue?vue&type=script&lang=ts"
export * from "./PendingStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports